import { module } from 'angular';
import templateBuilderJsonEditorDisplay from './builder/display.html';

export default module('app').run(/* @ngInject */ (
	/** @type {import('angular').ITemplateCacheService} */ $templateCache,
) => {
	$templateCache.put('kform/components/htmlelement/display.html', templateBuilderJsonEditorDisplay);
});
